import { gql } from '@apollo/client'

export default gql(`
    mutation deleteAssetCreditLinks($input: [ID] $assetId: ID $project:String $module: String) {
        deleteAssetCreditLinks(
            input: $input
            assetId: $assetId
            project: $project
            module: $module
        )
    }`
)
